import { createSelector } from "reselect";
import sequenceDataSelector from "./sequenceDataSelector";
import temporaryAnnotationsSelector from "./temporaryAnnotationsSelector";
import searchMutationFeaturesSelector from "./searchMutationFeaturesSelector";
function featuresRawSelector(sequenceData, temporaryAnnotations, searchMutationFeatures) {
  return {
    ...sequenceData.features,
    ...temporaryAnnotations?.features,
    ...searchMutationFeatures
  };
}
export default createSelector(
  sequenceDataSelector,
  temporaryAnnotationsSelector,
  searchMutationFeaturesSelector,
  featuresRawSelector
);
